(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["external-links"] && !Shopify.designMode) return;
  try {
    (function() {
  function isExternalLink(anchor) {
    if (!anchor.href) return false;
    try {
      var linkUrl = new URL(anchor.href, window.location.href);
      return linkUrl.origin !== window.location.origin;
    } catch (e) {
      return false;
    }
  }
  function updateExternalLinks(root) {
    var links = (root || document).querySelectorAll('a[href]');
    links.forEach(function(link) {
      if (isExternalLink(link)) {
        link.setAttribute('target', '_blank');
        var rel = (link.getAttribute('rel') || '').split(/[\s,]+/).filter(Boolean);
        if (rel.indexOf('noopener') === -1) rel.push('noopener');
        if (rel.indexOf('noreferrer') === -1) rel.push('noreferrer');
        link.setAttribute('rel', rel.join(' '));
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateExternalLinks();
    });
  } else {
    updateExternalLinks();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-modal"] && !Shopify.designMode) return;
  try {
    (function () {
    var modal = document.querySelector('.dmm-newsletter-modal');
    if (!modal) return;

    var closeButton = modal.querySelector('.dmm-newsletter-modal-close');
    var delaySecondsAttr = modal.getAttribute('data-delay-seconds');
    var cookieNameAttr = modal.getAttribute('data-cookie-name');

    var COOKIE_NAME = cookieNameAttr || 'dmmNewsletterModalWasOpen';
    var delayMs = (parseInt(delaySecondsAttr, 10) || 5) * 1000;
    var ONE_YEAR_MS = 3600 * 1000 * 24 * 365;

    function getCookie(name) {
      var value = '; ' + document.cookie;
      var parts = value.split('; ' + name + '=');
      if (parts.length === 2) return parts.pop().split(';').shift();
      return '';
    }

    function setCookie(name, value, maxAgeMs) {
      var expires = new Date(Date.now() + maxAgeMs).toUTCString();
      document.cookie = name + '=' + value + '; expires=' + expires + '; path=/; SameSite=Lax';
    }

    function openModal() {
      modal.style.display = 'flex';
      modal.removeAttribute('hidden');
      modal.setAttribute('aria-hidden', 'false');
    }

    function closeModal() {
      modal.style.display = 'none';
      modal.setAttribute('hidden', 'hidden');
      modal.setAttribute('aria-hidden', 'true');
    }

    if (!getCookie(COOKIE_NAME)) {
      window.setTimeout(function () {
        openModal();
        setCookie(COOKIE_NAME, 'true', ONE_YEAR_MS);
      }, delayMs);
    }

    window.addEventListener('click', function (event) {
      if (event.target === modal) {
        closeModal();
      }
    });

    if (closeButton) {
      closeButton.addEventListener('click', closeModal);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
